(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('formatScorer', formatScorer);

    function formatScorer(lodash) {
        return function(value) {
            let template = '<span class="background-image droid-2"></span>';
            if (value === undefined) {
                return template;
            }
            const score = parseFloat(value);
            if (!lodash.isNaN(score)) {

                const score = parseFloat(value);
                let colorClass = '';

                if (score >= 70) {
                    colorClass = 'color-green';
                } else {
                    if (score < 30) {
                        colorClass = 'color-red';
                    } else {
                        colorClass = 'color-amber';
                    }
                }
                template += `<span class="${colorClass}">${value}%</span>`
            }

            return template;
        }
    }
})();